// LEGACY_NAME: yi-spinner
import React from 'react';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

import { charcoalGrey, greyBackground } from '~/styles';

const animationId = 'main-spinner-animation';
const rotateAnimation = `
 @keyframes ${animationId}{

  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;

export interface SpinnerProps {
  size?: number;
  spinnerColor?: string;
  backgroundColor?: string;
  style?: React.CSSProperties;
  className?: string;
}

const SpinnerWithoutStyles: React.FC = ({ ...props }) => {
  return <div aria-label="loading" {...props} />;
};

const styles = ({ backgroundColor = greyBackground, size = 50, spinnerColor = charcoalGrey }) => `
  ${rotateAnimation}
  background: linear-gradient(to right, ${spinnerColor} 10%, rgba(255, 255, 255, 0) 42%);
  width: ${size}px;
  height: ${size}px;
  font-size: 10px;
  margin: 50px auto;
  margin-top: 20px;
  margin-bottom: 20px;
  text-indent: -9999em;
  border-radius: 50%;
  position: relative;
  animation: ${animationId} 1.4s infinite linear;
  transform: translateZ(0);
  &:before {
    width: 50%;
    height: 50%;
    background: ${spinnerColor};
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  &:after {
    background: ${backgroundColor};
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

export const Spinner = styled(SpinnerWithoutStyles, {
  shouldForwardProp: prop =>
    isPropValid(prop) && !['backgroundColor', 'size', 'spinnerColor'].includes(prop),
})<SpinnerProps>`
  ${styles}
`;
